require('./hireContactDataForm.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const { sortByOrder } = require('lodash/collection');
const trim = require('lodash/string/trim');
import classNames from 'classnames';

// @helpers
const { FormattedText, formatText } = require('core/i18n').i18n;
const PersonalDataHelper = require('utilities/personalDataHelper');
const { noOrdinaryCharactersRegExp } = require('commonsUtilities/validations');

// @components
import FeatureTogglingRender from 'components/conditionalRender/featureTogglingRender';
const OKSelect = require('components/commons/OKSelect/OKSelect');

// @commons
const { InputSafe } = require('commonsComponents/inputSafe');

// @actions
const hireContactDataActions = require('actions/hireContactData');

// @constants
const { countryOptions } = require('constants/countries');
const { sortedTypesOfRoadsOptions } = require('constants/typeOfRoads');
const provinces = require('constants/provinces');

const sortedProvincesOptions = sortByOrder(
    Object.keys(provinces).map(key => ({
        value: key,
        label: provinces[key]
    })
    ),
    ['label'],
    ['asc']
);
const {
    NON_NUMERIC_REGEXP,
    PHONE_NUMBER_MAX_LENGTH,
    SPAIN_COUNTRY_CODE,
} = require('constants/index');
const { PROVINCE, TYPE_OF_ROAD } = require('constants/flagBasedFeatures');

// @hocs
import withFeatureToggling from 'hocs/withFeatureToggling/withFeatureToggling';


class HireContactDataForm extends React.Component {
    constructor(props){
        super(props);

        this.setProvinceAndValidatePostalCode = this.setProvinceAndValidatePostalCode.bind(this);
        this.handleMobilePhoneChange = this.handleMobilePhoneChange.bind(this);
        this.handleMobilePhoneFocus = this.handleMobilePhoneFocus.bind(this);
    }

    componentDidMount() {
        const {
            instanceId,
            originCountry,
            prepopulate,
            setupInitialData,
            emptyFields
        } = this.props;

        setupInitialData(prepopulate, instanceId, originCountry);
        
        if (emptyFields) {
            this.clearFields();
        }
    }
       
    clearFields() {
        const { setField, instanceId } = this.props;
        const fieldsToClear = ['mobile', 'roadName', 'number', 'others', 'postalCode', 'province', 'population'];
        fieldsToClear.forEach(field => setField(field, '', instanceId));
    }

    handleChangeValidatePopulation(event, instanceId) {
        const {
            setField,
        } = this.props;

        const {
            name,
            value,
        } = event.target;

        if (PersonalDataHelper.isValidRoadNameInput(value)) {
            setField(name, value, instanceId);
        }
    }

    handleMobilePhoneChange(name, value) {
        const { instanceId, setField } = this.props;

        setField(name, trim(value.replace(NON_NUMERIC_REGEXP, "")), instanceId);
    }

    handleMobilePhoneFocus(name) {
        const {
            instanceId,
            setField,
        } = this.props;

        let immHireContactData = this.props.immHireContactData;

        if (instanceId) {
            immHireContactData = immHireContactData.getIn(['extraInstances',instanceId]);
        }

        if (immHireContactData.getIn([name, 'value']).includes('*')) {
            setField(name, '', instanceId);
        }
    }

    setProvinceAndValidatePostalCode(provinceValue) {
        const { immHireContactData, instanceId, setField, validateField } = this.props;

        setField('province', provinceValue, instanceId);
        if (immHireContactData.getIn(['postalCode', 'value']) !== ''){
            validateField('postalCode', instanceId);
        }
    }

    handleStreetNumberChange(name, value, instanceId) {
        const { setField } = this.props;
        const normalizedValue = value.replace(NON_NUMERIC_REGEXP, '').trim();
        setField(name, normalizedValue, instanceId);
    }

    render() {
        const {
            flagBasedFeatures,
            mobileReadOnly,
            originCountry,
            readOnly,
            setField,
            showMobileDataForm,
            showSubHeader,
            validateField,
            instanceId,
        } = this.props;

        let immHireContactData = this.props.immHireContactData;

        if (instanceId) {
            if (!immHireContactData.hasIn(['extraInstances',instanceId])) {
                return <div></div>;
            }
            immHireContactData = immHireContactData.getIn(['extraInstances',instanceId]);
        }

        const mandatoryFieldErrorMsg = formatText('hireContactDataForm-hireContactDataForm_mandatoryFieldError');
        const mobileErrorState = immHireContactData.getIn(['mobile', 'isDirty']) && !immHireContactData.getIn(['mobile', 'isValid']);
        const mobileErrorType = immHireContactData.getIn(['mobile', 'errorType']);
        const roadTypeLabel = formatText('hireContactDataForm-hireContactDataForm_roadType');
        const roadNameLabel = formatText('hireContactDataForm-hireContactDataForm_roadName');
        const roadNameErrorState = immHireContactData.getIn(['roadName', 'isDirty']) && !immHireContactData.getIn(['roadName', 'isValid']);
        const numberLabel = formatText('hireContactDataForm-hireContactDataForm_number');
        const numberErrorState = immHireContactData.getIn(['number', 'isDirty']) && !immHireContactData.getIn(['number', 'isValid']);
        const othersLabel = formatText('hireContactDataForm-hireContactDataForm_others');
        const postalCodeLabel = formatText('hireContactDataForm-hireContactDataForm_postalCode');
        const postalCodeErrorState = immHireContactData.getIn(['postalCode', 'isDirty']) && !immHireContactData.getIn(['postalCode', 'isValid']);
        const postalCodeErrorType = immHireContactData.getIn(['postalCode', 'errorType']);
        const provinceErrorState = immHireContactData.getIn(['province', 'isDirty']) && !immHireContactData.getIn(['province', 'isValid']);
        const countryLabel = formatText('hireContactDataForm-hireContactDataForm_country');
        const countryErrorState = immHireContactData.getIn(['country', 'isDirty']) && !immHireContactData.getIn(['country', 'isValid']);
        const populationLabel = formatText('hireContactDataForm-hireContactDataForm_population');
        const populationErrorState = immHireContactData.getIn(['population', 'isDirty']) && !immHireContactData.getIn(['population', 'isValid']);
        const provinceLabel = formatText('hireContactDataForm-hireContactDataForm_province');
        const combosPlaceholder = formatText('hireContactDataForm-hireContactDataForm_combosPlaceholder');
        const disabledMobile = readOnly || mobileReadOnly;
        const sortedRoadsOptions = sortedTypesOfRoadsOptions();

        const typeOfRoadIsVisible = flagBasedFeatures.get(TYPE_OF_ROAD);
        const provinceIsVisible = flagBasedFeatures.get(PROVINCE);
        const streetNameClassName = classNames('hire-contact-data-form__input-grid-section', {
            'col-xs-8': typeOfRoadIsVisible,
            'col-xs-12': !typeOfRoadIsVisible
        });
        const noProvinceNameClassName = classNames('hire-contact-data-form__input-grid-section', {
            'col-xs-4': provinceIsVisible,
            'col-xs-6': !provinceIsVisible
        });

        let mobileErrorMessage = mandatoryFieldErrorMsg;
        let postalCodeErrorMessage = mandatoryFieldErrorMsg;

        if (!!mobileErrorType && mobileErrorType === 'format') {
            mobileErrorMessage = formatText('hireContactDataForm-hireContactDataForm_wrongMobileFormat');
        }

        if (!!postalCodeErrorType && postalCodeErrorType === 'province-mismatch') {
            postalCodeErrorMessage = formatText('hireContactDataForm-hireContactDataForm_postalCodeProvinceMismatch');
        }

        let mobileDataForm = null;
        if ( showMobileDataForm ) {
            mobileDataForm = (
                <div className="row">
                    <label className="col-xs-12 ok-select__label">
                        <FormattedText value="hireContactDataForm-hireContactDataForm_mobilePhone" />
                    </label>
                    <div className="col-xs-2">
                        <InputSafe
                            disabled={true}
                            type="text"
                            value={`+${SPAIN_COUNTRY_CODE}`}
                        />
                    </div>
                    <div className="col-xs-6">
                        <InputSafe
                            disabled={disabledMobile}
                            errorMessage={mobileErrorMessage}
                            errorState={mobileErrorState}
                            label={null}
                            name="mobile"
                            maxLength={PHONE_NUMBER_MAX_LENGTH}
                            onBlur={(event) => validateField(event.target.name, instanceId)}
                            onChange={(event) => this.handleMobilePhoneChange(event.target.name, event.target.value)}
                            onFocus={(event) => this.handleMobilePhoneFocus(event.target.name)}
                            referenceName="mobile"
                            type="text"
                            value={immHireContactData.getIn(['mobile', 'value'])}
                        />
                    </div>
                </div>
            );
        }

        let subHeader = null;
        if ( showSubHeader ) {
            subHeader = (<h5 className="row hire-contact-data-form__subheader">
                <FormattedText
                    className="col-xs-12"
                    value="hireContactDataForm-hireContactDataForm_subheader"
                />
            </h5>);
        }

        return (
            <article className="hire-contact-data-form">
                {mobileDataForm}
                {subHeader}
                <div className="row">
                    <div className="col-xs-12 hire-contact-data-form__input-grid-section">
                        <OKSelect
                            disabled
                            errorMessage={mandatoryFieldErrorMsg}
                            errorState={countryErrorState}
                            label={countryLabel}
                            name="country"
                            options={countryOptions()}
                            placeholder={combosPlaceholder}
                            searchable={true}
                            value={originCountry}
                        />
                    </div>
                </div>
                <div className="row">
                    <FeatureTogglingRender notAllowedProductKey={TYPE_OF_ROAD} >
                        <div className="col-xs-4 hire-contact-data-form__input-grid-section">
                            <OKSelect
                                disabled={readOnly}
                                label={roadTypeLabel}
                                name="roadType"
                                onChange={(event) => setField('roadType', event.value, instanceId)}
                                options={sortedRoadsOptions}
                                placeholder={combosPlaceholder}
                                searchable={true}
                                value={immHireContactData.getIn(['roadType', 'value'])}
                            />
                        </div>
                    </FeatureTogglingRender>
                    <div className={streetNameClassName}>
                        <InputSafe
                            disabled={readOnly}
                            errorMessage={mandatoryFieldErrorMsg}
                            errorState={roadNameErrorState}
                            label={roadNameLabel}
                            maxLength={32}
                            name="roadName"
                            onBlur={(event) => validateField(event.target.name, instanceId)}
                            onChange={(event) => {
                                const { name, value } = event.target;
                                if (!value || (PersonalDataHelper.isValidRoadNameInput(value) && noOrdinaryCharactersRegExp.test(value)) ) {
                                    return setField(name, value, instanceId);
                                }
                            }}
                            type="text"
                            value={immHireContactData.getIn(['roadName', 'value'])}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-6 hire-contact-data-form__input-grid-section">
                        <InputSafe
                            disabled={readOnly}
                            errorMessage={mandatoryFieldErrorMsg}
                            errorState={numberErrorState}
                            label={numberLabel}
                            maxLength={7}
                            name="number"
                            onBlur={(event) => validateField(event.target.name, instanceId)}
                            onChange={(event) => this.handleStreetNumberChange(event.target.name, event.target.value, instanceId)}
                            type="text"
                            value={immHireContactData.getIn(['number', 'value'])}
                        />
                    </div>
                    <div className="col-xs-6 hire-contact-data-form__input-grid-section">
                        <InputSafe
                            disabled={readOnly}
                            label={othersLabel}
                            maxLength={40}
                            name="others"
                            onBlur={(event) => validateField(event.target.name, instanceId)}
                            onChange={(event) => {
                                const { name, value } = event.target;
                                if (!value || noOrdinaryCharactersRegExp.test(value)) {
                                    setField(name, value, instanceId)
                                }
                            }}
                            type="text"
                            value={immHireContactData.getIn(['others', 'value'])}
                        />
                    </div>
                </div>
                <div className="row">
                    <FeatureTogglingRender notAllowedProductKey={PROVINCE} >
                        <div className="col-xs-4 hire-contact-data-form__input-grid-section">
                            <OKSelect
                                disabled={readOnly}
                                errorMessage={mandatoryFieldErrorMsg}
                                errorState={provinceErrorState}
                                label={provinceLabel}
                                name="province"
                                onChange={(event) => this.setProvinceAndValidatePostalCode(event.value)}
                                options={sortedProvincesOptions}
                                placeholder={combosPlaceholder}
                                searchable={true}
                                value={immHireContactData.getIn(['province', 'value'])}
                            />
                        </div>
                    </FeatureTogglingRender>
                    <div className={noProvinceNameClassName}>
                        <InputSafe
                            disabled={readOnly}
                            errorMessage={mandatoryFieldErrorMsg}
                            errorState={populationErrorState}
                            label={populationLabel}
                            maxLength="50"
                            name="population"
                            onBlur={(event) => validateField(event.target.name, instanceId)}
                            onChange={event => {
                                const { value } = event.target;
                                if(!value || noOrdinaryCharactersRegExp.test(value)){
                                    this.handleChangeValidatePopulation(event, instanceId)
                                }
                            }}
                            type="text"
                            value={immHireContactData.getIn(['population', 'value'])}
                        />
                    </div>
                    <div className={noProvinceNameClassName}>
                        <InputSafe
                            disabled={readOnly}
                            errorMessage={postalCodeErrorMessage}
                            errorState={postalCodeErrorState}
                            label={postalCodeLabel}
                            maxLength={8}
                            name="postalCode"
                            // TODO: ADDRESS
                            // onBlur={(event) => validateField(event.target.name, instanceId)}
                            onChange={(event) => setField(event.target.name, event.target.value, instanceId)}
                            type="text"
                            value={immHireContactData.getIn(['postalCode', 'value'])}
                        />
                    </div>
                </div>
            </article>
        );
    }
}

HireContactDataForm.propTypes = {
    flagBasedFeatures: PropTypes.object.isRequired,
    createInstance: PropTypes.func.isRequired,
    immHireContactData: PropTypes.object.isRequired,
    setupInitialData: PropTypes.func.isRequired,
    mobileReadOnly: PropTypes.bool,
    originCountry: PropTypes.string.isRequired,
    prepopulate: PropTypes.bool.isRequired,
    readOnly: PropTypes.bool,
    reset: PropTypes.func.isRequired,
    setField: PropTypes.func.isRequired,
    showMobileDataForm: PropTypes.bool,
    showSubHeader: PropTypes.bool,
    validateField: PropTypes.func.isRequired,
    instanceId: PropTypes.string,
};


HireContactDataForm.defaultProps = {
    mobileReadOnly: false,
    prepopulate: true,
    readOnly: false,
    showMobileDataForm: true,
    showSubHeader: true,
    instanceId: '',
}

module.exports.constructor = HireContactDataForm;

module.exports.HireContactDataForm = connect(
    state => ({
        originCountry: state.profile.get('originCountry')
    }),
    {
        createInstance: hireContactDataActions.createInstance,
        setupInitialData: hireContactDataActions.setupInitialData,
        reset: hireContactDataActions.reset,
        setField: hireContactDataActions.setField,
        validateField: hireContactDataActions.validateField,
    }
)(withFeatureToggling(HireContactDataForm));
